import React, {useRef, useEffect} from 'react'
import {Container, Screen} from './coverPageStyles'
import mainLogo from "../../assets/ademars/APxM_logo_Stacked-02.png";
import {TimelineMax, Power3} from 'gsap'
import $ from 'jquery'

const CoverPage = ({comicRef}) => {
    
    // ref
    let logoRef = useRef(null);

    useEffect(() => {
        let tl = new TimelineMax();
        tl.to(logoRef, {
          duration: 1.2,
          opacity: 1,
          ease: Power3.easeInOut,
          delay: 0.8,
        });
        tl.to(logoRef, {
          duration: 1,
          height: "100%",
          ease: Power3.easeInOut,
        })
    }, []);


    return(
        <Container>
            <Screen>
                <div>
                    <img 
                        ref={(ref) => {
                            logoRef = ref;
                        }}
                        src={mainLogo} 
                    />
                </div>
            </Screen>
      </Container>
    )
}


export default CoverPage